import { styled } from '@styledComponents';
import { themeColor, themeSpace } from '@utils/styledTheme.util';
import { variant } from 'styled-system';
import { TypographyVariant } from '@components/themes';

interface SelectProps {
  typography?: TypographyVariant | TypographyVariant[];
}

export const StyledSelect = styled.select<SelectProps>`
  display: block;

  ${variant({
    prop: 'typography',
    scale: 'typography',
  })};

  width: 100%;
  height: 48px;
  line-height: 24px;
  padding: ${themeSpace(4)} ${themeSpace(8)} ${themeSpace(4)} ${themeSpace(5)};
  box-sizing: border-box;
  margin: 0;
  border-radius: 4px;
  border: 1px solid ${themeColor('mono3')};
  color: ${themeColor('mono1')};
  background: transparent;

  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;

  &:focus {
    border-color: #aaa;
    box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);
    box-shadow: 0 0 0 3px -moz-mac-focusring;
    color: #222;
    outline: none;
  }
`;
StyledSelect.defaultProps = {
  typography: 'featureCopy17',
};

export const SelectWrapper = styled.div`
  position: relative;
  z-index: 0;
  background-color: ${themeColor('mono7')};
`;
export const StyledArrowSvg = styled.svg`
  position: absolute;
  top: ${themeSpace(4)};
  right: ${themeSpace(5)};
  z-index: -1;
`;
